import React from 'react';
import { Calculator as CalcIcon } from 'lucide-react';
import { useT } from '../utils/i18n';
import { MaterialCalculator } from '../components/MaterialCalculator';
export function Calculator() {
  const t = useT();
  return <main className="py-12 md:py-20 bg-[#fdfbf7] dark:bg-[#1b1b1b] min-h-[calc(100vh-64px)]" data-id="element-2194">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2195">
        <div className="mb-8 text-center md:text-left" data-id="element-2196">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-brand-charcoal dark:text-white flex items-center justify-center md:justify-start" data-id="element-2197">
            <CalcIcon className="w-8 h-8 mr-3 text-brand-orange" data-id="element-2198" />
            {t('calc.title')}
          </h1>
          <p className="text-stone-700 dark:text-stone-300 mt-2 text-lg" data-id="element-2199">
            {t('calc.subtitle')}
          </p>
        </div>
        <MaterialCalculator variant="page" data-id="element-2200" />
      </div>
    </main>;
}